// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3B_Zc","label":"Completed_label__3woWZ"};